var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSignOutDialogIcon = function SvgSignOutDialogIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 5,
    fill: "#1F2E56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35 34 4-4m0 0-4-4m4 4H25m6 4v1a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3V25a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgSignOutDialogIcon;